import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-custom-card',
  templateUrl: './custom-card.component.html',
  styleUrls: ['./custom-card.component.scss'],
})
export class CustomCardComponent {
  @Input() imagen!: string;
  @Input() titulo!: string;
  @Input() texto!: string;

  @Input() videoId?: string;  // Ahora solo recibimos el ID del video de YouTube

  showModal = false;
  videoUrl?: SafeResourceUrl;

  constructor(public sanitizer: DomSanitizer) {}

  abrirModal() {
    if (this.videoId) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        'https://www.youtube.com/embed/' + this.videoId + '?autoplay=1'
      );
      this.showModal = true;
    }
  }

  cerrarModal() {
    this.showModal = false;
  }
}
